<router-outlet />
@if (navigating()) {
  <div class="lazy-module-backdrop active"></div>
  <spinner class="lazy-module-spinner" />
}
